<template>
  <div class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">{{pageTitle}}</h3>
          </div>
          <div class="box-body">
            <el-tabs v-model="query.type_id" @tab-click="typeSelect">
              <el-tab-pane v-for="(item, i) in typeList" :key="i" :label="item.name" :name="item.id + ''"></el-tab-pane>
            </el-tabs>

            <el-card class="box-card" shadow="never">
              <div class="query">
                <el-form :inline="true">
                  <el-form-item label="搜索">
                    <el-input v-model="query.keyword" clearable placeholder="输入企业名称搜索"></el-input>
                  </el-form-item>
                  <el-form-item label="状态">
                    <el-select v-model="query.status" placeholder="请选择状态" >
                      <el-option label="全部" :value="0"></el-option>
                      <el-option label="未支付" :value="1"></el-option>
                      <el-option label="已支付" :value="2"></el-option>
                      <el-option label="已取消" :value="3"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" :disabled="loading" @click="querySearch">查询</el-button>
                  </el-form-item>
                </el-form>
              </div>

              <el-table :data="list" border style="width: 100%" v-loading="loading">
                <el-table-column prop="organize_name" label="充值企业"></el-table-column>
                <el-table-column prop="admin_name" label="充值人"></el-table-column>
                <el-table-column prop="admin_mobile" label="充值人手机"></el-table-column>
                <el-table-column prop="buy_price" label="充值金额(元)" width="100"></el-table-column>
                <el-table-column prop="buy_duration" label="充值时长(天)" width="100"></el-table-column>
                <el-table-column prop="buy_num" label="充值数量" width="80"></el-table-column>
                <el-table-column label="充值状态" width="80">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.status === 1">{{scope.row.status_desc}}</el-tag>
                    <el-tag v-if="scope.row.status === 2" type="success">{{scope.row.status_desc}}</el-tag>
                    <el-tag v-if="scope.row.status === 3" type="info">{{scope.row.status_desc}}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="商品信息">
                  <template slot-scope="scope">
                    <div>
                      <span v-for="(item, i) in scope.row.goods_list" :key="i">
                        {{ item }}
                      </span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="update_at" label="操作时间"></el-table-column>
                <el-table-column label="操作" width="200">
                  <template slot-scope="scope">
                    <div style="display: flex;align-items: center;">
                      <page-detail :param="scope.row">详情</page-detail>
                      <page-delete v-if="scope.row.status === 1" :param="scope.row" @finish="finish">关闭订单</page-delete>
                    </div>
                  </template>
                </el-table-column>
              </el-table>

              <div v-if="list.length > 0">
                <div style="height: 20px;"></div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :current-page="query.page"
                    :page-size="query.size"
                    :total="total"
                    @current-change="pageSelect"
                >
                </el-pagination>
              </div>

            </el-card>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import {mapState} from "vuex";

import PageDetail from "@/views/order/recharge/Detail.vue";
import PageDelete from "@/views/order/recharge/Delete.vue";

export default {
  components: {
    PageDetail,
    PageDelete,
  },
  data() {
    return {
      loading: false,
      query: {
        type_id: 0,
        status: 0,
        keyword: '',
        page: 1,
        size: 10
      },
      list: [],
      total: 0,
      canNext: false,
      nextPage: 1,
      typeList: [],
    };
  },
  computed: mapState({
    config: (state) => state.config,
    pageTitle: (state) => state.pageTitle,
  }),
  mounted() {
    const _this = this;
    _this.query = Object.assign(_this.query, _this.$route.query)
    _this.query.status = parseInt(_this.query.status);
    _this.query.page = parseInt(_this.query.page);
    _this.query.size = parseInt(_this.query.size);
    _this.loading = true;
    _this.$store
        .dispatch('authInit', _this)
        .then(() => {
          _this.loadSelect();
        })
        .catch(() => {
          _this.loading = false;
        })
  },
  methods: {
    updateUrl() {
      const _this = this;
      const url = _this.$queryUrl(_this.$route.path, _this.query);
      _this.$router.replace({path: url});
    },
    querySearch() {
      const _this = this;
      _this.query.page = 1;
      _this.loading = true;
      _this.loadList();
    },
    pageSelect(page) {
      const _this = this;
      _this.query.page = parseInt(page);
      _this.loading = true;
      _this.loadList();
    },
    loadSelect() {
      const _this = this;
      _this.$apiAdmin.adminRechargeTypeList()
          .then(res => {
            _this.typeList = res.type_list;
            if (_this.typeList.length > 0 && _this.query.type_id === '0') {
              _this.query.type_id = _this.typeList[0].id + '';
            }
            _this.loadList();
          })
          .catch(() => {
            _this.loading = false;
            _this.updateUrl();
          })
    },
    loadList() {
      const _this = this;
      _this.$apiAdmin.adminRechargeList(_this.query)
          .then(res => {
            _this.loading = false;
            _this.list = res.list;
            _this.total = res.total;
            _this.canNext = res.can_next;
            _this.nextPage = res.next_page;
            _this.updateUrl();
          })
          .catch(err => {
            _this.loading = false;
            _this.updateUrl();
          })
    },
    finish(res) {
      const _this = this;
      _this.loading = true;
      _this.loadList();
    },
    typeSelect() {
      const _this = this;
      _this.loading = true;
      _this.loadList();
    },
  }
}
</script>


<style scoped>
.custom-tree-node {
  display: flex;
  justify-content: space-between;
}

.custom-tree-node-name {
  width: 400px;
}
</style>